import React from 'react';
import { TableCell, TableFooter, TableRow } from '@material-ui/core';
import { floatRenderer } from '../../services/formatSvc';

export default function BuysRegisterTableFooter(props) {
  const currentColumns = props.columns.filter((c) => !c.hidden);
  const aggFields = ['assessedValue'];
  const first = currentColumns.findIndex((c) => c.aggregated);
  const last = currentColumns.findLastIndex((c) => c.aggregated);

  const total = props.renderData.reduce(
    (acc, row) => {
      aggFields.forEach((f) => {
        acc[f] = (acc[f] * 100 + (row[f] ?? 0) * 100) / 100;
      });
      return acc;
    },
    aggFields.reduce((acc, field) => ({ ...acc, [field]: 0 }), {}),
  );
  // поля первичного объекта складываются из списка полей столбцов, по которым требуется итоговая сумма
  return (
    <TableFooter style={{ position: 'sticky', bottom: '0', zIndex: 15 }}>
      <TableRow style={{ backgroundColor: '#FFF' }}>
        {props.actions && props.actions.length > 0 && <TableCell style={totalCellStyle}></TableCell>}
        <TableCell style={totalCellStyle} colSpan={first}>
          ИТОГО
        </TableCell>
        {Object.keys(total).map((key) => (
          <TableCell key={key} style={totalCellStyle}>
            {new Intl.NumberFormat("ru", {
              minimumFractionDigits: 2,
            }).format(total[key])}
          </TableCell>
        ))}
        {currentColumns.length - last > 0 && <TableCell colSpan={currentColumns.length - last} />}
      </TableRow>
    </TableFooter>
  );
}

const totalCellStyle = { color: 'inherit', fontWeight: 'bold' };
